module.exports = __webpack_public_path__ + "static/cal-save-tax-icon-f22db4906ba9a09ed058f9ba9de7a5f4.svg";